import { Outlet } from 'react-router-dom'

const AdministracaoLayout: React.FC = () => {
  return <Outlet />
}

export default AdministracaoLayout
